export default __webpack_public_path__ + "static/media/P1000-sm-open.fb6e8155.svg";